(() => {
  const root = document.querySelector('[data-cart-page]');
  if (!root) return;

  const form = root.querySelector('[data-cart-form]');
  if (!form) return;
  const discountMessage = form.querySelector('[data-cart-discount-message]');
  const updateBtn = form.querySelector('[data-cart-update]');

  const moneyFormat = root.getAttribute('data-money-format') || '';

  const syncQtyBaselines = () => {
    form.querySelectorAll('[data-qty-input]').forEach((input) => {
      input.setAttribute('data-qty-initial', String(input.value || '0'));
    });
  };

  const syncUpdateButton = () => {
    if (!updateBtn) return;
    const dirty = Array.from(form.querySelectorAll('[data-qty-input]')).some((input) => {
      const initial = input.getAttribute('data-qty-initial');
      return String(input.value || '0') !== String(initial ?? input.defaultValue ?? '0');
    });
    updateBtn.disabled = !dirty;
  };

  syncQtyBaselines();
  syncUpdateButton();

  form.addEventListener('input', (event) => {
    if (event.target && event.target.matches && event.target.matches('[data-qty-input]')) {
      syncUpdateButton();
    }
  });

  form.addEventListener('change', (event) => {
    if (event.target && event.target.matches && event.target.matches('[data-qty-input]')) {
      syncUpdateButton();
    }
  });

  const formatMoney = (cents) => {
    const noDecimalFormat = moneyFormat
      .replace('amount_with_comma_separator', 'amount_no_decimals_with_comma_separator')
      .replace('amount_with_space_separator', 'amount_no_decimals_with_space_separator')
      .replace('{{amount}}', '{{amount_no_decimals}}')
      .replace('{{ amount }}', '{{amount_no_decimals}}');

    if (window.Shopify?.formatMoney && noDecimalFormat) {
      return window.Shopify.formatMoney(cents, noDecimalFormat);
    }

    const whole = Math.round(Number(cents || 0) / 100).toString();
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return grouped;
  };

  const updateCartCount = (count) => {
    document.querySelectorAll('.header__icon-btn--cart').forEach((button) => {
      let badge = button.querySelector('.header__cart-count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'header__cart-count';
          button.appendChild(badge);
        }
        badge.textContent = String(count);
        badge.hidden = false;
      } else if (badge) {
        badge.remove();
      }
    });
  };

  const paintCart = (cart) => {
    if (!cart.items?.length) {
      window.location.reload();
      return;
    }

    const existingRows = Array.from(form.querySelectorAll('.cart-page__row'));
    const existingKeys = new Set(existingRows.map((row) => row.getAttribute('data-line-key')));
    const hasUnknownLineKey = cart.items.some((item) => !existingKeys.has(item.key));
    if (hasUnknownLineKey) {
      window.location.reload();
      return;
    }

    const remaining = new Set(cart.items.map((item) => item.key));

    form.querySelectorAll('.cart-page__row').forEach((row) => {
      const key = row.getAttribute('data-line-key');
      if (!remaining.has(key)) row.remove();
    });

    cart.items.forEach((item) => {
      const row = form.querySelector(`.cart-page__row[data-line-key="${CSS.escape(item.key)}"]`);
      if (!row) return;

      const qtyInput = row.querySelector('[data-qty-input]');
      const subtotal = row.querySelector('.cart-page__td--subtotal');
      const mobilePrice = row.querySelector('.cart-page__mobile-price');

      if (qtyInput) qtyInput.value = String(item.quantity);
      if (subtotal) {
        const label = subtotal.getAttribute('data-label');
        subtotal.textContent = formatMoney(item.final_line_price);
        if (label) subtotal.setAttribute('data-label', label);
      }
      if (mobilePrice) mobilePrice.textContent = formatMoney(item.final_price);
    });

    syncQtyBaselines();
    syncUpdateButton();

    const totals = form.querySelectorAll('.cart-page__totals-table td');
    if (totals[0]) totals[0].textContent = formatMoney(cart.items_subtotal_price);
    if (totals[totals.length - 1]) totals[totals.length - 1].textContent = formatMoney(cart.total_price);

    updateCartCount(cart.item_count);
  };

  const postCart = async (url, payload) => {
    form.classList.add('is-updating');
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!response.ok) throw new Error('Cart update failed');
      const cart = await response.json();
      paintCart(cart);
    } catch (error) {
      console.error(error);
    } finally {
      form.classList.remove('is-updating');
    }
  };

  const setDiscountMessage = (message) => {
    if (!discountMessage) return;
    if (message) {
      discountMessage.textContent = message;
      discountMessage.hidden = false;
      return;
    }
    discountMessage.textContent = '';
    discountMessage.hidden = true;
  };


  form.addEventListener('click', (event) => {
    const remove = event.target.closest('[data-cart-remove]');
    if (!remove) return;
    event.preventDefault();
    event.stopPropagation();
    postCart('/cart/change.js', { id: remove.getAttribute('data-cart-remove'), quantity: 0 });
  });

  const applyDiscount = async () => {
    const input = form.querySelector('[data-cart-discount]');
    const code = input?.value?.trim();
    if (!code) {
      input?.focus();
      return;
    }

    form.classList.add('is-updating');
    setDiscountMessage('');
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code }),
      });
      if (!response.ok) throw new Error('Discount update failed');

      const cart = await response.json();
      const appliedDiscounts = Array.isArray(cart.cart_level_discount_applications)
        ? cart.cart_level_discount_applications
        : [];

      if (!appliedDiscounts.length) {
        setDiscountMessage(`Coupon "${code}" cannot be applied because it does not exist.`);
      } else {
        setDiscountMessage('');
      }

      paintCart(cart);
    } catch (error) {
      console.error(error);
      setDiscountMessage(`Coupon "${code}" cannot be applied because it does not exist.`);
    } finally {
      form.classList.remove('is-updating');
    }
  };

  form.querySelector('[data-cart-apply-discount]')?.addEventListener('click', (event) => {
    event.preventDefault();
    applyDiscount();
  });

  form.querySelector('[data-cart-discount]')?.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      applyDiscount();
    }
  });

  form.addEventListener('submit', (event) => {
    const invalidQtyInputs = Array.from(form.querySelectorAll('[data-qty-input]')).filter(
      (input) => !input.checkValidity()
    );
    if (!invalidQtyInputs.length) return;

    event.preventDefault();
    form.reportValidity();

    window.setTimeout(() => {
      invalidQtyInputs.forEach((input) => {
        const maxAttr = Number.parseInt(input.getAttribute('max') || '', 10);
        if (!Number.isFinite(maxAttr)) return;
        input.value = String(maxAttr);
      });
    }, 180);
  });

})();
